
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.942 18.25c.652 0 1.158-.184 1.518-.553.36-.37.54-.918.54-1.646V8.449c0-.723-.189-1.27-.566-1.642-.377-.371-.936-.557-1.676-.557h-11.2c-.652 0-1.158.186-1.518.557-.36.371-.54.919-.54 1.642v7.602c0 .728.189 1.277.566 1.646.377.369.936.553 1.676.553h11.2zm-5.681-5.301a.886.886 0 01-.397-.098 1.745 1.745 0 01-.419-.31L6.3 7.505l.064-.02c.109-.027.23-.04.363-.04h11.046c.164 0 .31.02.437.064l.01.004-5.143 5.028a1.59 1.59 0 01-.42.313.915.915 0 01-.396.095zm-6.57 3.1V8.463l3.88 3.785-3.88 3.8zm13.118-.015l-3.862-3.789 3.862-3.761v7.55zm-1.036 1.03H6.727c-.133 0-.254-.015-.363-.042l-.06-.018 4.06-3.983.412.401c.25.243.497.418.74.525.242.106.49.16.745.16.25 0 .497-.054.742-.16.245-.107.49-.282.735-.525l.416-.404L18.206 17l-.074.022a1.446 1.446 0 01-.359.041z","fill":"#848E9D"}})])
          )
        }
      }
    